<div class="add-container">
    <div class="d-flex justify-content-between align-items-center">
        <h1 class="add-title m-0 p-0">Detalii email</h1>
        <button class="action-buttons-side" (click)="closeDialog()">x</button>
    </div>
    <br>

    <div *ngIf="hasHistory()" class="col d-flex justify-content-start mb-3">
        <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="toggleView($event)"
            [value]="currentView">
            <mat-button-toggle value="detalii">Detalii Email</mat-button-toggle>
            <mat-button-toggle value="istoric">Istoric Mesaje</mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <div class="email-details-view" *ngIf="currentView === 'detalii'">
        <!-- Informații email -->
        <div class="email-info-section">
            <div class="info-row">
                <strong>Subiect:</strong>
                <span>{{ emailData.subject }}</span>
            </div>
            <div class="info-row" *ngIf="emailData.type === 'received'">
                <strong>De la:</strong>
                <span>{{ emailData.from_name }} &lt;{{ emailData.from_email }}&gt;</span>
            </div>
            <ng-container *ngIf="emailData.type !== 'received'">
                <div class="info-row">
                    <strong>De la:</strong>
                    <span>{{ emailData.sent_by_user_name }}</span>
                </div>
                <div class="info-row">
                    <strong>Către:</strong>
                    <span>{{ emailData.to_name }} &lt;{{ emailData.to_email }}&gt;</span>
                </div>
            </ng-container>
            <div class="info-row">
                <strong>CC:</strong>
                <span>{{ emailData.to_cc || '-' }}</span>
            </div>
            <div class="info-row">
                <strong>Dată primit:</strong>
                <span>{{ emailData.received_date_time | date : "dd.MM.yyyy HH:mm" : "ro" }}</span>
            </div>
            <div class="info-row">
                <strong>Dată procesat:</strong>
                <span>{{ emailData.created_date_time | date : "dd.MM.yyyy HH:mm" : "ro" }}</span>
            </div>
        </div>

        <div class="email-content-section">
            <h4>Conținut Email</h4>
            <div class="email-body" [innerHTML]="emailData.body"></div>
        </div>

        <div class="attachments-section" *ngIf="emailData.inboxFisiere && emailData.inboxFisiere.length > 0">
            <h4>Atașamente ({{ emailData.inboxFisiere.length }})</h4>
            <div class="attachments-list">
                <div class="attachment-item" *ngFor="let attachment of emailData.inboxFisiere">
                    <div class="attachment-icon" [class.not-processed]="!attachment.processed_server">
                        <span class="file-extension">{{ attachment.extension.toUpperCase() }}</span>
                    </div>

                    <div class="attachment-info">
                        <div class="attachment-name" [title]="attachment.name_original">
                            {{ attachment.name_original }}
                        </div>
                    </div>

                    <button *ngIf="attachment.processed_server" class="attachment-download"
                        (click)="downloadAttachment(attachment)" [title]="'Descarcă ' + attachment.name_original">
                        <i class="fa-solid fa-download"></i>
                        Descarcă
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Vizualizare istoric mesaje -->
    <div *ngIf="currentView === 'istoric'" class="history-section">
        <h4>Istoric Mesaje</h4>

        <div *ngFor="let msg of emailData.historyMessages" class="history-item"
            [class.expanded]="isHistoryMessageExpanded(msg.id)">

            <div class="history-header" (click)="msg.body !== '' ? toggleHistoryMessage(msg.id) : null"
                [class.no-expand]="msg.body === ''">
                <div class="history-header-left">
                    <span class="history-type">{{ msg.type_label }}</span>
                    <span class="history-date">
                        {{ msg.sent_date_time | date: 'dd.MM.yyyy HH:mm:ss' }}
                    </span>
                </div>
                <i *ngIf="msg.body !== ''" class="expand-icon fa-solid"
                    [class.fa-chevron-down]="!isHistoryMessageExpanded(msg.id)"
                    [class.fa-chevron-up]="isHistoryMessageExpanded(msg.id)"></i>
            </div>

            <div class="history-preview">
                <p><strong>De la:</strong> {{ msg.sent_by_user_name ? msg.sent_by_user_name : msg.from_name }}
                    &lt;{{ msg.from_email }}&gt;</p>
                <p><strong>Către:</strong> {{ msg.to_name }} &lt;{{ msg.to_email }}&gt;</p>
                <p><strong>Subiect:</strong> {{ msg.subject }}</p>
                <p *ngIf="msg.to_cc"><strong>CC:</strong> {{ msg.to_cc }}</p>
                <p *ngIf="msg.attachments_count > 0">
                    <strong>Atașamente:</strong> {{ msg.attachments_count }}
                </p>

                <!-- Preview al conținutului -->
                <div class="history-preview-body" *ngIf="!isHistoryMessageExpanded(msg.id) && msg.body !== ''">
                    <span class="preview-text">{{ getPlainTextPreview(msg.body, 120) }}</span>
                </div>
            </div>

            <div class="history-body" *ngIf="isHistoryMessageExpanded(msg.id)">
                <div class="history-body-content" [innerHTML]="msg.body"></div>

                <!-- Secțiune atașamente pentru mesajul din istoric -->
                <div class="history-attachments" *ngIf="msg.attachments && msg.attachments.length > 0">
                    <h5>Atașamente ({{ msg.attachments.length }})</h5>

                    <div class="attachments-list">
                        <div class="attachment-item" *ngFor="let attachment of msg.attachments">
                            <div class="attachment-icon" [class.not-processed]="!attachment.processed_server">
                                <span class="file-extension">
                                    {{ attachment.extension.toUpperCase() }}
                                </span>
                            </div>

                            <div class="attachment-info">
                                <div class="attachment-name" [title]="attachment.name_original">
                                    {{ attachment.name_original }}
                                </div>
                                <div class="attachment-meta" *ngIf="attachment.doc_id">
                                    <span class="meta-badge">
                                        Înregistrat: {{ attachment.doc_id }}
                                    </span>
                                </div>
                            </div>

                            <button *ngIf="attachment.processed_server" class="attachment-download"
                                (click)="downloadHistoryAttachment(attachment, $event)"
                                [title]="'Descarcă ' + attachment.name_original">
                                <i class="fa-solid fa-download"></i>
                                Descarcă
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col d-flex justify-content-between">
            <button class="buttons" type="button" mat-stroked-button (click)="closeDialog()">
                {{ helper.dialogConfig.buttonLabels.close }}
            </button>
            <button class="buttons" type="button" mat-flat-button color="info" (click)="print(emailData.id)">
                <i class="fa fa-download"></i>
                {{ emailData.print_type === 'email' ? 'Print email' : 'Print atașament' }}
            </button>
        </div>
    </div>

    <div class="section-spinner position-fixed" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>